<template>
  <div>
    <v-card class="pa-2 pt-0 pb-0">
      <v-container>
        <v-row
          no-gutters
          align="center"
          class="mb-3"
        >
          <v-col class="headline">
            Arrange Meeting
          </v-col>

          <v-col cols="auto">
            <v-btn
              small
              fab
              icon
              @click="hideModal"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          class="mb-3"
          no-gutters
        >
          <v-col
            cols="12"
            class="title text-center"
          >
            {{ profile.name }}
          </v-col>
          <v-col cols="12">
            <ProfileContact :profile="profile" />
          </v-col>
        </v-row>

        <v-row
          no-gutters
          class="text-center"
        >
          <!-- <v-col cols=12 class="title">
                    {{opportunity.headline}}
                </v-col> -->

          <v-col class="text-center my-3">
            <v-btn
              rounded
              dark
              color="secondary"
              @click="confirm"
            >
              Confirm
            </v-btn>
          </v-col>

          <v-col
            cols="12"
            class="caption"
          >
            Confirming will notify the applicant that already have or will be in contact
            regarding the opportunity.
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import ProfileContact from '@/components/core/ProfileContact' 
export default {
  props: ['opportunity', 'profile'],
  components: {
    ProfileContact
  },
  methods: {
    hideModal () {
      this.$emit('hide')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.caption {
  color: grey;
}
</style>
